module.exports = __webpack_public_path__ + "static/media/bloodTestResult.35f196d4.svg";